<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
      <a [routerLink]="['/']">Home</a>
    </li>
    <li>
     Tag
    </li> 
  </ul>
  
  <section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong>Tag </strong>
      </span>
      <span style="float: right">
        <button class="btn btn-sm btn-primary" type="button"  
          [appHasPermission]="{'Url': '/group/edit?goveva=true&email=', 'method':'put', 'menu': 'Tag'}" (click)="add()">
          <i class="fa fa-plus"></i>&nbsp;Add Tag</button>
      </span>
    </div>
    <div class="card-block datatable-card-block">
      <div class="row" style="cursor: pointer;width:-webkit-fill-available !important;">  
        <div class="col-md-12" style="cursor: pointer;width:-webkit-fill-available !important;">
          <div class="margin-bottom-50" style="cursor: pointer;width:-webkit-fill-available !important;">
  
            <div class="table-responsive" style="width:-webkit-fill-available !important;">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-hover compact cell-border nowrap"
                id="groupTable" style="cursor: pointer;width:-webkit-fill-available !important;">
                <thead style="cursor: pointer;width:-webkit-fill-available !important;">
                  <tr style="cursor: pointer;width:-webkit-fill-available !important;">
                    <th>Tag  </th>
                    <th class="group-list-action"><span [appHasPermission]="{'Url': '/group/edit?goveva=true&email=', 'method':'put', 'menu': 'Tag'}">Action</span></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let group of groups;">
                    <td tabindex="1">{{group.GroupName }}</td>
                    <td class="group-list-action">
                      <button type="button" class="btn-sm btn btn-warning" (click)="loadGroupToEdit(group._id)" [appHasPermission]="{'Url': '/group/edit?goveva=true&email=', 'method':'put', 'menu': 'Tag'}">
                        <span class="fa fa-pencil"></span>
                      </button>&nbsp;&nbsp;&nbsp;
                      <button type="button" class="btn-sm btn btn-danger" (click)="deleteConfirmation(group._id)" [appHasPermission]="{'Url': '/group/edit?goveva=true&email=', 'method':'put', 'menu': 'Tag'}">
                        <span class="icmn-bin"></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
  
            </div>
  
            <div class="modal fade modal-size-medium" id="groupDialog" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <form [formGroup]="groupMasterForm" class="well" (keydown)="keyDownEnterFunction($event)">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="myModalLabel">Tag</h5>
                      <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <i class="fa fa-times"></i>
                      </button>
                    </div>
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-3">
                          <label class="form-control-label" for="l0">Tag
                            <span _ngcontent-c2="" style="color: red;">*</span>
                          </label>
                        </div>
                        <div class="col-md-9">
                          <div class="form-group">
  
                            <input [formControl]="groupMasterForm.controls['GroupName']" class="form-control" id="groupName">
                            <div *ngIf="groupMasterForm.controls['GroupName'].hasError('required') && groupMasterForm.controls['GroupName'].touched"
                              class="form-control-error-custom">
                              Tag name is required.
                            </div>
                            <div *ngIf="groupMasterForm.controls['GroupName'].hasError('pattern') && groupMasterForm.controls['GroupName'].touched" class="form-control-error-custom">
                              Please enter a valid Tag name.
                            </div>
                          </div>
                        </div>
  
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button id="btnsaveGroup" type="button" class="btn btn-sm btn-primary" [disabled]="!groupMasterForm.valid" (click)="addgroup()">
                        <i class="fa fa-save"></i>&nbsp;Save
                      </button>
                      <button id="btnupdateGroup" style="display:none;" type="button" class="btn btn-sm btn-primary" [disabled]="!groupMasterForm.valid"
                        (click)="editGroup()">
                        <i class="fa fa-save"></i>&nbsp;Update
                      </button>
                      <button type="button" class="btn btn-sm" data-dismiss="modal">
                        <i class="fa fa-times"></i>&nbsp;Close
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
  
  
  
            <div class="modal fade" id="confirmation" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="" aria-hidden="true" style="top: 50px;">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="myModalLabelForDelete">
                      <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="row">
                      <div class="col-sm-12">
                        Are you sure you want to delete the Tag?
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-danger" (click)="deleteGroup()">
                      <i class="fa fa-check"></i>&nbsp;Yes
                    </button>
                    <button type="button" class="btn btn-sm" data-dismiss="modal">
                      <i class="fa fa-times"></i>&nbsp;No
                    </button>
                  </div>
                </div>
              </div>
            </div>
  
          </div>
        </div>
      </div>
    </div>
  </section>
  <app-alert></app-alert>